import { DataSource, Layout } from "@mcleod/components";
import { AgenciesWithPrimary } from "@mcleod/general";

export abstract class AutogenLayoutCustomerUsers extends Layout {
    agenciesWithPrimary: AgenciesWithPrimary;
    sourceAgencyLink: DataSource;
    sourceCustomer: DataSource;
}
